import styles from "./NaveBar.module.css";
import logo from "../../Imgs/Logo001.png";
import { Link } from "react-scroll";
import MenuMobile from "./MenuMobile";

function NaveBar(){
  return(
    <nav className={styles.navebar}>
        <img src={logo} alt="Geografia em jogos ufpel"></img>
        <ul id={styles.menupcId}>
          <li>
            <Link to="inicio" spy={true} smooth={true} offset={-210} duration={50}>Início</Link>
          </li>
          <li>
            <Link to="sobre" spy={true} smooth={true} offset={-130} duration={50}>Sobre</Link>
          </li>
          <li>
            <Link to="equipe" spy={true} smooth={true} offset={-110} duration={50}>Equipe</Link>
          </li>
          <li>
            <Link to="referencias" spy={true} smooth={true} offset={-135} duration={50}>Referencial
            <br /> teórico</Link>
          </li>
          <li>
            <Link to="resultados" spy={true} smooth={true} offset={-115} duration={50}>Produções</Link>
          </li>
          <li>
            <Link to="contato" spy={true} smooth={true} offset={-130} duration={50}>Contato</Link>
          </li>
        </ul>
        <MenuMobile></MenuMobile>
    </nav>
  )
} export default NaveBar

